module.exports = __webpack_public_path__ + "static/media/donate.4b5f2b7b.svg";